var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.90373 14.2584L0.903666 14.259C0.884769 14.4413 0.950837 14.6235 1.08322 14.7512C1.20169 14.8655 1.36042 14.9286 1.5225 14.9286H1.52456C1.54127 14.9286 1.56475 14.9286 1.5893 14.9254L5.79515 14.4953L5.7954 14.4953C5.93725 14.4804 6.06878 14.4207 6.1697 14.3205C6.16989 14.3203 6.17008 14.3201 6.17027 14.32L15.9165 4.91744C16.1618 4.68073 16.1618 4.29406 15.9165 4.05735L12.1576 0.431051C11.9143 0.19629 11.5198 0.196291 11.2764 0.43105L1.52914 9.83464C1.42951 9.93076 1.36263 10.061 1.34956 10.2002L0.90373 14.2584ZM11.9101 7.07996L5.44927 13.3129L2.22817 13.6411L2.56752 10.5405L9.03232 4.3037L11.9101 7.07996ZM12.7964 6.22486L9.91868 3.4486L11.7183 1.7124L14.5961 4.48866L12.7964 6.22486Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9181 16.704C11.2584 16.704 11.5427 16.4349 11.5427 16.0979C11.5427 15.761 11.2584 15.4918 10.9181 15.4918H2.09932C1.75897 15.4918 1.47471 15.761 1.47471 16.0979C1.47471 16.4349 1.75897 16.704 2.09932 16.704H10.9181Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.386c2892d729900b0c2aef61629c2d76.svg";
export { ForwardRef as ReactComponent };